import {UseFileUpload} from '../../firebase/hooks/useFileUpload';
import {useUserFileUpload} from './useUserFileUpload';

const PublicDirectory = 'public';

export function usePublicUserFileUpload(userId: string, path: string, ...segments: string[]): UseFileUpload {
  return useUserFileUpload(userId, PublicDirectory, path, ...segments);
}
